import PropTypes from 'prop-types';
import QuestionsAndAnswersListItem from './QuestionsAndAnswersListItem';
import React from 'react';


/**
 * Display a list of questions.
 * @component
 */
const QuestionsAndAnswersList = ({ questions = [] }) => 
    (!Array.isArray(questions) || questions.length < 1)
        ? <p>There are no questions for this product yet.</p>
        : <>
            {questions.map((question, index) => <QuestionsAndAnswersListItem
                key={index}
                question={question}
            />)}
        </>;

/** Prop Types */
QuestionsAndAnswersList.propTypes = {
    /** The list of questions to display. */
    questions: PropTypes.array,
};

export default QuestionsAndAnswersList;
